'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _FlatButton = require('material-ui/FlatButton');

var _FlatButton2 = _interopRequireDefault(_FlatButton);

var _WMThemeProvider = require('../common/WMThemeProvider');

var _WMThemeProvider2 = _interopRequireDefault(_WMThemeProvider);

var _styles = require('../common/styles');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var propTypes = {
	backgroundColor: _propTypes2.default.string,
	children: _propTypes2.default.any,
	disabled: _propTypes2.default.bool,
	hoverColor: _propTypes2.default.string,
	href: _propTypes2.default.string,
	icon: _propTypes2.default.any,
	label: _propTypes2.default.string,
	labelPosition: _propTypes2.default.oneOf(['before', 'after']),
	labelStyle: _propTypes2.default.object,
	onKeyboardFocus: _propTypes2.default.func,
	onMouseEnter: _propTypes2.default.func,
	onMouseLeave: _propTypes2.default.func,
	onClick: _propTypes2.default.func,
	primary: _propTypes2.default.bool,
	secondary: _propTypes2.default.bool,
	style: _propTypes2.default.object
};

var WMFlatButton = function WMFlatButton(props) {
	return _react2.default.createElement(
		_WMThemeProvider2.default,
		null,
		_react2.default.createElement(_FlatButton2.default, _extends({}, props, {
			labelStyle: _extends({}, _styles.typography.button, props.labelStyle)
		}))
	);
};

exports.default = WMFlatButton;


// WEBPACK FOOTER //
// ./~/@workmarket/front-end-components/dist/WMFlatButton/index.js